import ApartmentsLookup from '@/features/apartments/components/ApartmentsLookup';
import { GetHotelListItemDto } from '@/features/hotels/types/hotels-dto';
import { NotificationCreateFormData } from '@/features/notifications/validators/NotificationCreateValidator';
import { t } from 'i18next';
import { FC } from 'react';
import { Control } from 'react-hook-form';

type Props = {
	hotels: GetHotelListItemDto[];
	control: Control<NotificationCreateFormData>;
};

const NotificationCreateStep2: FC<Props> = ({ control, hotels }) => {
	return (
		<div className='flex flex-col gap-4'>
			{hotels.map((hotel, index) => (
				<ApartmentsLookup
					key={hotel.id}
					label={hotel.name}
					fieldName={`hotels.${index}.apartmentIds`}
					control={control}
					selectVariant='multi'
					hotelId={hotel.id}
					placeholder={t('elements.form.apartments.placeholder')}
				/>
			))}
		</div>
	);
};

export default NotificationCreateStep2;
